import { connect } from 'react-redux';
import { languageMapRoute } from 'util/i18n';

import Footer from './component';

const mapStateToProps = ({ i18n: { lan } }) => ({
	lan,
	mapLanguage: languageMapRoute(lan),
});

export default connect(mapStateToProps)(Footer);



// WEBPACK FOOTER //
// ./src/components/organisms/Footer/index.js